module.exports = __webpack_public_path__ + "assets/img/Type E.f54ffe1b.jpg";